export { default as localeData } from 'react-intl/locale-data/pt';
export { default as messages } from './messages/pt-skymais.json';
export const parentLocale = 'pt';
